import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getConsultationAgentBranchFee = (branchId, agentId) => {
  return http.get(
    `${getBaseUrl()}/consultation_agent_branch_fee/${branchId}/${agentId}`
  );
};

export const getServiceAgentBranchFeeInfo = (agentId, branchId) => {
  return http.get(
    `${getBaseUrl()}/service_agent_branch_fee_info/${agentId}/${branchId}`
  );
};

export const getConsultationAgentBranchFees = agent_id => {
  return http.get(
    `${getBaseUrl()}/consultation_agent_branch_fees/${agent_id}`
  );
};

export const getConsultationFieldAgentBranchFees = (data) => {
  return http.get(
    `${getBaseUrl()}/consultation_field_agent_branch_fees?${data}`
  );
};

export const getServiceFieldAgentBranchFees = (data) => {
  return http.get(
    `${getBaseUrl()}/service_field_agent_branch_fees?${data}`
  );
};

export const getServiceAgentBranchFees = agent_id => {
  return http.get(
    `${getBaseUrl()}/service_agent_branch_fees/${agent_id}`
  );
};

export const getAgentBranchFees = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_branch_fee`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_branch_fee?${paginate}`
  );
};

export const updateAgentBranchFee = data => {

  return http.put(
    `${getBaseUrl()}/agent_branch_fee`,
    data
  );
};
export const submitAgentBranchFee = data => {

  return http.post(
    `${getBaseUrl()}/agent_branch_fee`,
    data
  );
};
